<template>
  <Button variant="link" size="small" leading-icon="plus-circle" />
</template>

<script setup>
import { Button } from 'laravel-nova-ui'
</script>
